import { Button } from '@/app/common/components/Button'
import { CircleLoader } from '@/app/common/components/CircleLoader'
import {
  REQUEST_STATUS,
  RequestStatus,
} from '@/app/common/types_and_interfaces'
import { ButtonHTMLAttributes } from 'react'
import { cn } from '@/common/utilities.ts'
import { MutationStatus } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

type Props = {
  status: RequestStatus | MutationStatus
  forceDisabled?: boolean
  buttonTxt?: string
  submittingText?: string
  children?: React.ReactNode
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'id' | 'disabled' | 'type'>

export function SubmitButton({
  status,
  forceDisabled,
  className,
  buttonTxt = 'Continue',
  submittingText = 'Submitting...',
  children,
  ...props
}: Props) {
  const isSubmitting =
    status === REQUEST_STATUS.IN_FLIGHT || status === 'pending'
  const { t: translate } = useTranslation()

  return (
    <Button
      disabled={isSubmitting || forceDisabled}
      className={cn('w-full', className)}
      type="submit"
      size={'lg'}
      {...props}
    >
      {isSubmitting ? (
        <span className="flex gap-1 items-center">
          <CircleLoader size="xsDisabledLoader" className="mr-1" />
          {translate(submittingText)}
        </span>
      ) : (
        <>{buttonTxt === 'Continue' ? translate('continue') : buttonTxt}{children}</>
      )}
    </Button>
  )
}
